const $$splitComponentImporter = () => import('/src/src/routes/_anonymous/event_checkin/$eventId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_anonymous/event_checkin/$eventId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Event Check In",
      description: "Page title"
    })
  }
});